import { APP_LANGUAGES } from "@/i18n/types/app-languages.types";
import type { TFunction } from "i18next";
import * as z from "zod";

export const onboardingFormSchema = (t: TFunction) => {
  return z.object({
    email: z.email({
      message: t("email_invalid"),
    }),
    firstName: z.string().min(2, {
      message: t("firstname_min_length"),
    }),
    lastName: z.string().min(2, {
      message: t("lastname_min_length"),
    }),
    preferredLanguage: z.enum(APP_LANGUAGES, {
      message: t("language_required"),
    }),
    notificationsEnabled: z.boolean(),
    file: z.instanceof(File).optional(),
  });
};

export type OnboardingFormValues = z.infer<
  ReturnType<typeof onboardingFormSchema>
>;
